export const DOWNS_TEXT = ['1st', '2nd', '3rd', '4th'];
export const DOWN_PREFIX = ['st', 'nd', 'rd', 'th'];
